import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.523 14.278c.151.088.227.132.334.155a.8.8 0 0 0 .286 0c.107-.023.183-.067.334-.155 1.332-.777 4.993-3.218 4.993-6.575V4.011c0-.382 0-.573-.073-.718a.68.68 0 0 0-.295-.298c-.144-.076-.338-.078-.726-.082C10.344 2.889 9.172 2.72 8 1.549c-1.172 1.172-2.344 1.34-4.376 1.364-.388.004-.582.006-.726.082a.68.68 0 0 0-.295.298c-.073.145-.073.336-.073.718v3.692c0 3.357 3.66 5.798 4.993 6.575" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }